export default "__VITE_ASSET__dST4TzxQ__"